import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorpageComponent } from './components/shared/errorpage/errorpage.component';
import { HomeComponent } from './components/pages/home/home.component';
import { AboutComponent } from './components/pages/about/about.component';
import { WorksComponent } from './components/pages/works/works.component';
import { LoginComponent } from './components/pages/login/login.component';
import { EditpageComponent } from './components/pages/editpage/editpage.component';
import { AuthguardService } from './services/authguard.service';
import { EditpaintingsComponent } from './components/pages/editpaintings/editpaintings.component';
import { NewPaintingComponent } from './components/pages/new-painting/new-painting.component';
import { PaintingComponent } from './components/pages/painting/painting.component';
import { ContactComponent } from './components/pages/contact/contact.component';



const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'works', component: WorksComponent },
  { path: 'painting/:id', component: PaintingComponent },
  { path: 'login', component: LoginComponent },
  {
    path: 'editpage',
    canActivate: [AuthguardService],
    component: EditpageComponent,
  },
  {
    path: 'editpaintings/:id',
    canActivate: [AuthguardService],
    component: EditpaintingsComponent,
  },
  {
    path: 'new-painting',
    canActivate: [AuthguardService],
    component: NewPaintingComponent,
  },

  { path: 'notfound', component: ErrorpageComponent },
  { path: '**', redirectTo: '/notfound' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
